var map = {
	"./pending_active.svg": 37014,
	"./pending_banned.svg": 60996,
	"./pending_failure.svg": 70334,
	"./pending_lock.svg": 7173,
	"./pending_locked.svg": 82738,
	"./pending_transport.svg": 97087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40396;